const SvgIconDots = (props) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={props.className}>
    <circle cx={5} cy={12} r={2} />
    <circle cx={12} cy={12} r={2} />
    <circle cx={19} cy={12} r={2} />
  </svg>
);

export default SvgIconDots;
